const normalize = (value) => String(value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

const featureNames = (app) => (Array.isArray(app.feature) ? app.feature : [app.feature])
  .filter(Boolean)
  .map(normalize);

export const applyCatalogLayout = (apps, catalog = []) => apps
  .map((app, index) => {
    const names = featureNames(app);
    const item = catalog.find((feature) => names.includes(normalize(feature.title)));
    return {
      ...app,
      catalogSection: item?.section_name?.trim() || (app.key === "paisa_vara" ? "Workspace" : "Business apps"),
      catalogSectionOrder: Number(item?.section_order ?? (app.key === "paisa_vara" ? -1 : 999)),
      catalogDisplayOrder: Number(item?.display_order ?? index),
    };
  })
  .sort((left, right) =>
    left.catalogSectionOrder - right.catalogSectionOrder ||
    left.catalogSection.localeCompare(right.catalogSection) ||
    left.catalogDisplayOrder - right.catalogDisplayOrder ||
    left.displayName.localeCompare(right.displayName)
  );

export const startsCatalogSection = (apps, index) =>
  index === 0 || apps[index - 1]?.catalogSection !== apps[index]?.catalogSection;
